<template>
  <w-td :colspan="colspan">
    <w-button
      ref="buttonRef"
      color="success"
      icon="add"
      radius="square"
      variant="tonal"
      :text="text"
      :disabled="model.$readOnly"
      @click.prevent="add"
    />
  </w-td>
</template>

<script setup lang="ts">
import type { IWrappedPropertyArray } from '@witkac/jschema';
import { nextTick, ref } from 'vue';

const {
  model,
  text = 'Dodaj wiersz',
  colspan = 1,
  count = 1,
  rowDefault = {},
} = defineProps<{
  /**
   * Model tablicy, do której ma zostać dodany wiersz. Powinien być typu IWrappedPropertyArray.
   */
  model: IWrappedPropertyArray;

  /**
   * Tekst przycisku dodawania wiersza. Domyślnie "Dodaj wiersz".
   */
  text?: string;

  /**
   * Liczba kolumn, które powinien zajmować przycisk dodawania wiersza. Domyślnie 1.
   */
  colspan?: number;

  /**
   * Liczba wierszy dodawanych za jednym kliknięciem przycisku. Domyślnie 1.
   */
  count?: number;

  /**
   * Domyślne wartości dla nowo dodawanego wiersza.
   */
  rowDefault?: object;
}>();

const emit = defineEmits<{
  rowAdded: [count: number];
  setFocus: [];
  addRow: [];
}>();

const buttonRef = ref<HTMLElement | null>(null);

async function add() {
  model.$addRow(rowDefault, count);
  emit('rowAdded', count);

  await nextTick();

  focusLastRow();
}

function focusLastRow() {
  const buttonEl = (buttonRef.value as any)?.$el;
  if (
    !buttonEl ||
    typeof buttonEl.closest !== 'function' ||
    typeof buttonEl.querySelector !== 'function'
  ) {
    return;
  }

  const tbody = buttonEl.closest('tbody');
  if (tbody) {
    const row2 = tbody.querySelector('tr:last-child');
    if (row2) {
      const field2 = row2.querySelector('input,select,textarea') as HTMLElement | null;
      if (field2) {
        field2.focus();
        return;
      }
    }
  }

  const table = buttonEl.closest('table');
  if (!table) {
    return emit('addRow');
  }

  const row = table.querySelector('tbody > tr:last-child');
  if (!row) {
    return emit('addRow');
  }

  const field = row.querySelector('input,select,textarea') as HTMLElement | null;
  if (!field) {
    return emit('addRow');
  }

  field.focus();
  emit('setFocus');
}
</script>
